import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import generateValidator from './Validations/generateValidator';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import AttributeOptions from './AttributeOptions.js';
import CustomSpinner from './CustomSpinner.js';
import SaveStepButton from './SaveStepButton';
import CustomAlert from './CustomAlert';


class PropertyForm extends Component {
    constructor(props){
        super(props);

        this.state = {
            accept_address: null,
        };
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const property_options = [{id:0 , name:'Si'}, {id:1 , name:'No'}]

        return (

             <Section className="intro_form">
                <div className="row">
                <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_has_property" description="Company type"/>
                    <div className="show-desktop">
                        <SaveStepButton/>
                    </div>
                    </div>
                     <div className="pd-content-right text-center short-content col-sm-12 col-md-7 col-lg-7">
                         <form onSubmit={handleSubmit(this.props.saveHasProperty)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className="form-group">
                                        <AttributeOptions name="has_property_title" defaultValue="¿Sos titular del inmueble?" label="¿Sos titular del inmueble?" attributeName="has_property_title" attributeOptions={property_options}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                          <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

PropertyForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

PropertyForm = TopScrolleable(PropertyForm);
let validate = generateValidator([{name: 'has_property_title', required: true}]);

PropertyForm = reduxForm({
    form: 'PropertyForm', // a unique name for this form
    validate
})(PropertyForm);

PropertyForm = withAuthControl(PropertyForm);

export default PropertyForm;



/** WEBPACK FOOTER **
 ** ./src/components/PropertyForm.js
 **/